// extracted by mini-css-extract-plugin
export var suptitle = "styles-module--suptitle--e7e73";